import { render, staticRenderFns } from "./Instruction.vue?vue&type=template&id=1cc818a8&scoped=true&"
import script from "./Instruction.vue?vue&type=script&lang=js&"
export * from "./Instruction.vue?vue&type=script&lang=js&"
import style0 from "./Instruction.vue?vue&type=style&index=0&id=1cc818a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc818a8",
  null
  
)

export default component.exports